(function () {
  'use strict';
  if (window.VCBCategoryNavigation) return;
  var stateSelector = '[data-vcb-category-navigation-state]';
  var html = document.documentElement;
  var initial = readState(document);
  if (!validState(initial) || String(initial.themeId) !== '155472199841') return;

  var committed = initial, renderedPath = location.pathname, active = null, queued = null;
  var generation = 0, requestGeneration = 0, vendorBusy = false, requestApp = null;
  var successful = 0, firstGrid = false, initialObserved = false, disabled = [], statusNode = null;
  var documentId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  var infrastructure = ['filter_id', 'form_id', 'shop', 'market_id', 'currency', 'country', 'cache',
    'locale', 'company_location_id', 'company_location_country', 'catalog_ids'];
  var sorts = /^(recommended|best-selling|manual|price-ascending|price-descending|title-ascending|title-descending|created-ascending|created-descending)$/;
  var protectedControls = '#gf-products, #gf-tree, #gf_pagination_wrap, [data-vcb-results-search], [data-vcb-results-sort]';
  html.setAttribute('data-vcb-category-document-id', documentId);
  html.setAttribute('data-vcb-category-navigation-count', '0');
  html.setAttribute('data-vcb-category-navigation-status', 'ready');

  function readState(doc) {
    try { var node = doc.querySelector(stateSelector); return node && JSON.parse(node.textContent); }
    catch (error) { return null; }
  }
  function normalPath(path) { return typeof path === 'string' ? path.replace(/\/$/, '') : ''; }
  function validState(value) {
    if (!value || value.version !== 1 || !Number.isSafeInteger(Number(value.collectionId)) ||
        Number(value.collectionId) <= 0 || !Number.isSafeInteger(Number(value.productsCount)) || Number(value.productsCount) < 0 ||
        !/^[a-z0-9-]+$/.test(value.collectionHandle || '') || !Array.isArray(value.tags) || value.tags.length !== 2 ||
        typeof value.tags[0] !== 'string' || !value.tags[0] || !/^[a-z0-9-]+$/.test(value.tags[1] || '') ||
        !['country', 'currency', 'locale', 'rootUrl', 'collectionUrl', 'path'].every(function (key) { return typeof value[key] === 'string' && !!value[key]; })) return false;
    try {
      var base = new URL(value.collectionUrl, location.origin);
      return base.origin === location.origin && !base.search && !base.hash &&
        /^\/(?:[a-z]{2,3}(?:-[a-z]{2})?\/)?collections\/[a-z0-9-]+$/i.test(normalPath(base.pathname)) &&
        normalPath(base.pathname).split('/').pop() === value.collectionHandle &&
        normalPath(value.path) === normalPath(base.pathname) + '/' + value.tags[1];
    } catch (error) { return false; }
  }
  function sameContext(value) {
    return validState(value) && ['themeId', 'themeRole', 'collectionId', 'collectionHandle', 'country', 'currency', 'locale', 'rootUrl', 'collectionUrl']
      .every(function (key) { return String(value[key]) === String(initial[key]); });
  }
  function cleanURL(url) {
    if (url.origin !== location.origin || url.hash || !sameContext(committed)) return false;
    var base = normalPath(new URL(initial.collectionUrl, location.origin).pathname) + '/';
    if (url.pathname.indexOf(base) !== 0 || !/^[a-z0-9-]+$/.test(url.pathname.slice(base.length))) return false;
    var clean = true;
    url.searchParams.forEach(function (value, key) {
      if (url.searchParams.getAll(key).length !== 1 ||
          key !== 'sort_by' && key !== 'preview_theme_id' ||
          key === 'sort_by' && !sorts.test(value) ||
          key === 'preview_theme_id' && value !== String(initial.themeId)) clean = false;
    });
    return clean;
  }
  function targetURL(value) {
    try {
      var url = new URL(value, location.href);
      if (!cleanURL(url)) return null;
      var current = new URL(location.href);
      if (current.searchParams.has('preview_theme_id') && !url.searchParams.has('preview_theme_id')) {
        url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
      }
      // Shopify can remove the preview parameter from the visible URL while an
      // older preview cookie remains. Every draft request must name this theme.
      if (String(initial.themeRole).toLowerCase() === 'unpublished') url.searchParams.set('preview_theme_id', String(initial.themeId));
      if (!url.searchParams.has('sort_by')) {
        var recommended = window.VCBRecommendedSort && window.VCBRecommendedSort.available();
        var collection = window.GloboEmbedFilterConfig && window.GloboEmbedFilterConfig.collection;
        var sort = recommended ? 'recommended' : collection && collection.sort || 'best-selling';
        url.searchParams.set('sort_by', sorts.test(sort) ? sort : 'best-selling');
      }
      return cleanURL(url) ? url : null;
    } catch (error) { return null; }
  }
  function responseMatches(response, requested) {
    if (!response.ok) return false;
    if (!response.url) return !response.redirected;
    try {
      var actual = new URL(response.url), expected = new URL(requested.href);
      if (actual.origin !== expected.origin || normalPath(actual.pathname) !== normalPath(expected.pathname)) return false;
      // Shopify sets its draft cookie and redirects to the same storefront URL
      // without preview_theme_id. The rendered state still must prove the theme.
      actual.searchParams.delete('preview_theme_id'); expected.searchParams.delete('preview_theme_id');
      actual.searchParams.sort(); expected.searchParams.sort();
      return actual.search === expected.search && !actual.hash;
    } catch (error) { return false; }
  }
  function app() { return window.globofilter; }
  var originalHistoryPush = history.pushState;
  history.pushState = function (state, title, url) {
    var g = app(), sameURL = url == null;
    if (!sameURL) {
      try { sameURL = new URL(url, location.href).href === location.href; } catch (error) {}
    }
    // Globo's 'all' renderer still pushes with a null URL when URL updates are
    // disabled. Replace that app snapshot; the controller already added exactly
    // one destination entry. Preserve all unrelated history calls.
    if (active && active.phase === 'render' && g && state === g.state && sameURL) {
      return history.replaceState.apply(history, arguments);
    }
    return originalHistoryPush.apply(this, arguments);
  };
  function splitState() { return window.VCBSplitResultsState && window.VCBSplitResultsState(); }
  function continuousState() { return window.VCBContinuousResults && window.VCBContinuousResults.status(); }
  function marketMatches(doc, value) {
    try {
      var node = doc.querySelector('[data-vcb-market-price-data]');
      var market = node && JSON.parse(node.textContent);
      return !!market && market.country === value.country && market.currency === value.currency &&
        normalPath(market.root) === normalPath(value.rootUrl);
    } catch (error) { return false; }
  }
  function appContextMatches(value) {
    var g = app(), config = window.GloboEmbedFilterConfig;
    if (!g || !g.state || !g.state.queryParams || !g.collection || !config || !config.collection) return false;
    var query = g.state.queryParams;
    return [g.collection, config.collection].every(function (collection) {
      return String(collection.id) === String(value.collectionId) && collection.handle === value.collectionHandle &&
        JSON.stringify(collection.tags) === JSON.stringify(value.tags) && !collection.vendor && !collection.type && !collection.term;
    }) && String(query.collection) === String(value.collectionId) && JSON.stringify(query.currentTags) === JSON.stringify(value.tags) &&
      (!query.country || query.country === value.country) && (!query.currency || query.currency === value.currency) &&
      (!query.locale || query.locale === value.locale) && (!window.currentCountry || window.currentCountry === value.country) &&
      (!window.currentCurrency || window.currentCurrency === value.currency) &&
      (!window.currentLanguageCode || window.currentLanguageCode === value.locale) && marketMatches(document, value);
  }
  function companionBusy() {
    var continuous = continuousState();
    return !!splitState() || !!(continuous && continuous.active && !continuous.ready) || html.hasAttribute('data-vcb-order-pending');
  }
  function basicReady() {
    var g = app();
    return !!(g && g.state && g.state.queryParams && g.state.pagination && typeof g.getFilterData === 'function' &&
      window.GloboEmbedFilterConfig && window.GloboEmbedFilterConfig.collection && document.getElementById('gf-products') &&
      typeof window.VCBCategoryPageRefresh === 'function' && appContextMatches(committed) && !vendorBusy && !companionBusy());
  }
  function emit(name, transition) {
    document.dispatchEvent(new CustomEvent(name, { detail: {
      from: transition.from, to: transition.url.pathname + transition.url.search, id: transition.id
    } }));
  }
  function monitorApp() {
    var g = app();
    if (!g || typeof g.getFilterData !== 'function' || requestApp === g) return;
    requestApp = g;
    var original = g.getFilterData;
    g.getFilterData = function () {
      var request = ++requestGeneration;
      vendorBusy = true;
      try {
        var result = original.apply(this, arguments);
        if (result && typeof result.catch === 'function') result.catch(function () {
          if (request === requestGeneration) vendorBusy = false;
        });
        return result;
      } catch (error) { if (request === requestGeneration) vendorBusy = false; throw error; }
    };
  }
  function markInitialGrid() {
    if (firstGrid || active || !initialObserved || !basicReady()) return;
    firstGrid = true;
    html.setAttribute('data-vcb-category-first-grid-ms', String(Math.round(performance.now())));
  }
  function loading(on) {
    if (on) {
      html.setAttribute('data-vcb-category-navigation-pending', '');
      html.setAttribute('data-vcb-category-navigation-status', 'loading');
      document.querySelectorAll(protectedControls).forEach(function (node) {
        disabled.push({ node: node, inert: node.hasAttribute('inert'), busy: node.getAttribute('aria-busy') });
        node.setAttribute('inert', ''); node.setAttribute('aria-busy', 'true');
      });
      var grid = document.getElementById('gf-products');
      if (grid) {
        statusNode = document.createElement('div');
        statusNode.className = 'vcb-category-navigation-loading';
        statusNode.setAttribute('role', 'status'); statusNode.setAttribute('aria-live', 'polite');
        var labels = document.querySelector('[data-vcb-order-first-paint]');
        statusNode.textContent = labels && labels.getAttribute('data-loading-label') || 'Loading products…';
        grid.before(statusNode);
      }
    } else {
      html.removeAttribute('data-vcb-category-navigation-pending');
      disabled.forEach(function (entry) {
        if (!entry.inert) entry.node.removeAttribute('inert');
        if (entry.busy === null) entry.node.removeAttribute('aria-busy'); else entry.node.setAttribute('aria-busy', entry.busy);
      });
      disabled = [];
      if (statusNode) statusNode.remove();
      statusNode = null;
    }
  }
  function freshQuery(previous, destination, url, collection) {
    var next = {};
    infrastructure.forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(previous, key) && previous[key] !== undefined) next[key] = JSON.parse(JSON.stringify(previous[key]));
    });
    next.collection = destination.collectionId;
    next.currentTags = destination.tags.slice();
    next.sort_by = url.searchParams.get('sort_by');
    next.page = 1;
    // Keep this page size for subsequent appends: two batches give the normal
    // desktop 60, while mobile can reveal its normal 30 in the first batch.
    next.limit = 30;
    if (Array.isArray(collection.excludeTags) && collection.excludeTags.length) next.excludeTags = collection.excludeTags.slice();
    return next;
  }
  function refreshHead(doc) {
    var title = doc.querySelector('title');
    if (title) document.title = title.textContent;
    ['meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:description"]',
      'meta[property="og:url"]', 'meta[name="twitter:title"]', 'meta[name="twitter:description"]', 'link[rel="canonical"]']
      .forEach(function (selector) {
        var next = doc.querySelector(selector), current = document.head.querySelector(selector);
        if (!next) { if (current) current.remove(); return; }
        if (current) current.setAttribute(selector.indexOf('link') === 0 ? 'href' : 'content', next.getAttribute(selector.indexOf('link') === 0 ? 'href' : 'content') || '');
        else document.head.appendChild(document.importNode(next, false));
      });
  }
  function scrollToCategoryHeading() {
    var heading = document.querySelector('.collection-banner .page-heading');
    if (!heading) return;
    var header = document.querySelector('.site-header');
    var navigation = window.VCBCategoryNavigation;
    var path = location.pathname, scrollGeneration = generation;
    var sticky = header && header.classList.contains('header-sticky');
    // Keep the compact header above the heading even when this landing point
    // is just below the normal header's full-height activation threshold.
    if (sticky) {
      var headerStyle = getComputedStyle(header);
      var fixed = /^(fixed|sticky)$/.test(headerStyle.position) || header.classList.contains('is-sticky');
      var spacer = fixed ? parseFloat(getComputedStyle(document.body).paddingTop) :
        header.offsetHeight - (parseFloat(headerStyle.paddingTop) || 0) - (parseFloat(headerStyle.paddingBottom) || 0) -
          (parseFloat(headerStyle.borderTopWidth) || 0) - (parseFloat(headerStyle.borderBottomWidth) || 0);
      html.setAttribute('data-vcb-category-heading-aligned', '');
      header.classList.add('is-sticky');
      document.body.style.paddingTop = Math.max(0, spacer || 0) + 'px';
      document.querySelectorAll('.announcement-bar').forEach(function (bar) { bar.style.display = 'none'; });
    }
    function align() {
      if (location.pathname !== path || generation !== scrollGeneration || !heading.isConnected) return;
      var offset = 8;
      if (sticky) {
        var mobile = window.matchMedia && window.matchMedia('(max-width:1024px)').matches;
        var bar = mobile && header.querySelector('.halo-header-mobile');
        var visibleHeader = bar && bar.offsetHeight > 0 ? bar : header;
        var top = parseFloat(getComputedStyle(header).top) || 0;
        offset += Math.max(0, top + visibleHeader.offsetHeight);
        if (mobile && window.VCBMobileShoppingOffset) offset = Math.max(8, window.VCBMobileShoppingOffset() + 4);
      }
      var target = Math.max(0, heading.getBoundingClientRect().top + window.scrollY - offset);
      if (navigation && sticky) navigation.headingScrollThreshold = Math.max(0, target - 2);
      if (Math.abs(window.scrollY - target) > 1) window.scrollTo({ top: target, left: 0, behavior: 'instant' });
    }
    align();
    // One frame accounts for the native header spacer update; never wait for
    // counts, images, appends or an animation before revealing the products.
    if (window.requestAnimationFrame) window.requestAnimationFrame(align);
  }
  function revealFirstGrid(transition) {
    if (transition.visible || !transition.rendered) return;
    transition.visible = true;
    html.removeAttribute('data-vcb-category-navigation-pending');
    html.setAttribute('data-vcb-category-navigation-status', 'rendered');
    html.setAttribute('data-vcb-category-navigation-first-grid-ms', String(Math.round(performance.now() - transition.started)));
    var grid = document.getElementById('gf-products');
    disabled.forEach(function (entry) { if (entry.node === grid && !entry.inert) entry.node.removeAttribute('inert'); });
    if (statusNode) statusNode.remove();
    statusNode = null;
    // The verified first batch is usable now. Keep filter changes and the next
    // category serialized until the app finishes its automatic extra page.
    scrollToCategoryHeading();
  }
  function fallback(transition, reason) {
    if (active !== transition) return;
    if (!/^(document|context|busy|recommendation|body|request|results|timeout|navigation)$/.test(reason || '')) reason = 'navigation';
    if (window.console && typeof window.console.warn === 'function') window.console.warn('[VCB category navigation] Full-page fallback:', reason);
    clearTimeout(transition.timeout); clearTimeout(transition.check);
    transition.controller.abort();
    html.setAttribute('data-vcb-category-navigation-status', 'fallback');
    html.setAttribute('data-vcb-category-navigation-fallback', reason);
    html.setAttribute('data-vcb-category-navigation-pending', '');
    var grid = document.getElementById('gf-products');
    if (grid) grid.setAttribute('inert', '');
    queued = null;
    // Keep the mask while the full page is loading; stale products must never be revealed.
    location.assign(transition.url.href);
  }
  function validRender(event, transition) {
    var g = app(), query = g && g.state && g.state.queryParams;
    if (!transition.destination || !query || String(query.collection) !== String(transition.destination.collectionId) ||
        JSON.stringify(query.currentTags) !== JSON.stringify(transition.destination.tags) ||
        query.sort_by !== transition.url.searchParams.get('sort_by') || normalPath(location.pathname) !== normalPath(transition.url.pathname)) return false;
    var products = event.detail && event.detail.products;
    if (!Array.isArray(products)) return false;
    var cards = Array.from(document.querySelectorAll('#gf-products > .halo-item'));
    if (!products.length) return cards.length === 0 && Number(g.state.pagination.total) === 0;
    if (cards.length < products.length) return false;
    return products.every(function (product) {
      if (!product.handle) return false;
      return cards.some(function (card) {
        var link = card.querySelector('a[href*="/products/"]');
        if (!link) return false;
        try { return new URL(link.getAttribute('href'), location.origin).pathname.split('/products/')[1] === product.handle; }
        catch (error) { return false; }
      });
    });
  }
  function checkComplete(transition) {
    if (active !== transition || !transition.rendered) return;
    var failure = splitState();
    if (failure && failure.status === 'error') { fallback(transition, 'results'); return; }
    revealFirstGrid(transition);
    if (vendorBusy || companionBusy()) {
      transition.check = setTimeout(function () { checkComplete(transition); }, 40); return;
    }
    clearTimeout(transition.timeout); clearTimeout(transition.check);
    window.preventUpdatePageUrl = transition.previousPreventUpdate;
    committed = transition.destination; renderedPath = location.pathname;
    successful += 1;
    html.setAttribute('data-vcb-category-navigation-count', String(successful));
    html.setAttribute('data-vcb-category-navigation-ms', String(Math.round(performance.now() - transition.started)));
    html.setAttribute('data-vcb-category-navigation-ready-ms', String(Math.round(performance.now() - transition.started)));
    html.setAttribute('data-vcb-category-navigation-path', renderedPath);
    html.setAttribute('data-vcb-category-navigation-status', 'ready');
    html.removeAttribute('data-vcb-category-navigation-fallback');
    active = null; loading(false);
    emit('vcb:category-navigation-complete', transition);
    if (queued) {
      var next = queued; queued = null;
      if (normalPath(next.pathname) !== normalPath(renderedPath)) begin(next);
    }
  }
  async function begin(url) {
    var transition = { id: ++generation, url: url, from: location.pathname + location.search,
      started: performance.now(), controller: new AbortController(), rendered: false, phase: 'document' };
    active = transition;
    ['document-ms', 'first-render-ms', 'first-grid-ms', 'ready-ms'].forEach(function (key) { html.removeAttribute('data-vcb-category-navigation-' + key); });
    emit('vcb:category-navigation-start', transition);
    loading(true);
    transition.timeout = setTimeout(function () { fallback(transition, 'timeout'); }, 12000);
    try {
      var response = await fetch(url.href, { credentials: 'same-origin', signal: transition.controller.signal, headers: { Accept: 'text/html' } });
      if (!responseMatches(response, url)) throw Error('document');
      var source = await response.text();
      if (active !== transition || transition.controller.signal.aborted) return;
      html.setAttribute('data-vcb-category-navigation-document-ms', String(Math.round(performance.now() - transition.started)));
      var destinationDocument = new DOMParser().parseFromString(source, 'text/html');
      var destination = readState(destinationDocument);
      if (!sameContext(destination) || normalPath(destination.path) !== normalPath(url.pathname) || !marketMatches(destinationDocument, destination)) throw Error('context');
      var g = app(), collection = window.GloboEmbedFilterConfig.collection;
      if (!g || !g.state || vendorBusy || !sameContext(committed) || !appContextMatches(committed)) throw Error('busy');
      if (url.searchParams.get('sort_by') === 'recommended') {
        var recommended = window.VCBRecommendedSort;
        if (!recommended || !recommended.available() || typeof recommended.ready !== 'function' || !await recommended.ready(url)) throw Error('recommendation');
        if (active !== transition || transition.controller.signal.aborted) return;
      }
      // The destination response already includes authoritative native prices.
      // Seeding is optional: the existing verified price fetch remains fallback.
      try {
        var nativePrices = window.VCBNativeMarketPrices;
        var priceNode = destinationDocument.querySelector('[data-vcb-market-price-data]');
        if (nativePrices && typeof nativePrices.seed === 'function' && priceNode) nativePrices.seed(JSON.parse(priceNode.textContent));
      } catch (error) {}
      var query = freshQuery(g.state.queryParams, destination, url, collection);
      transition.destination = destination;
      transition.previousPreventUpdate = window.preventUpdatePageUrl;
      window.preventUpdatePageUrl = true;
      history.pushState(null, '', url.pathname + url.search);
      collection.tags = destination.tags.slice();
      collection.products_count = Number(destination.productsCount);
      if (g.collection !== collection) { g.collection.tags = destination.tags.slice(); g.collection.products_count = Number(destination.productsCount); }
      g.state.queryParams = query;
      if (window.VCBCategoryPageRefresh(destinationDocument) !== true) throw Error('body');
      refreshHead(destinationDocument);
      var stateNode = document.querySelector(stateSelector);
      if (stateNode) stateNode.textContent = JSON.stringify(destination);
      document.querySelectorAll('[data-vcb-results-sort]').forEach(function (select) { select.value = query.sort_by; });
      document.querySelectorAll('[data-vcb-search-input]').forEach(function (input) { input.value = ''; });
      emit('vcb:category-navigated', transition);
      transition.phase = 'render';
      var result = g.getFilterData('all', true);
      if (result && typeof result.catch === 'function') result.catch(function () { fallback(transition, 'request'); });
    } catch (error) { fallback(transition, error && error.message || 'navigation'); }
  }
  window.addEventListener('globoFilterRenderCompleted', function (event) {
    initialObserved = true;
    var request = requestGeneration, transition = active;
    if (transition && transition.phase === 'render' && validRender(event, transition) && !transition.rendered) {
      transition.rendered = true;
      html.setAttribute('data-vcb-category-navigation-first-render-ms', String(Math.round(performance.now() - transition.started)));
    }
    // Globo dispatches before its history write and busy reset. Companions may also
    // schedule the next page from this event, so wait until the following task.
    setTimeout(function () {
      if (request === requestGeneration) vendorBusy = false;
      if (transition && active === transition) checkComplete(transition);
      else markInitialGrid();
    }, 0);
  });
  function handleClick(event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    var node = event.target && event.target.closest && event.target.closest('a[href], button[data-vcb-category-url]');
    if (!node || node.hasAttribute('download') || node.getAttribute('target') && node.getAttribute('target') !== '_self') return false;
    var url = targetURL(node.getAttribute('data-vcb-category-url') || node.getAttribute('href'));
    if (!url || !cleanURL(new URL(location.href))) return false;
    if (!active && !basicReady()) {
      if (String(initial.themeRole).toLowerCase() !== 'unpublished') return false;
      event.preventDefault(); event.stopImmediatePropagation();
      location.assign(url.href);
      return true;
    }
    if (normalPath(url.pathname) === normalPath(location.pathname) && !active) return false;
    event.preventDefault(); event.stopImmediatePropagation();
    if (active) queued = url;
    else begin(url);
    return true;
  }
  document.addEventListener('click', handleClick, true);
  window.addEventListener('popstate', function (event) {
    if (active || normalPath(location.pathname) !== normalPath(renderedPath)) {
      event.stopImmediatePropagation();
      if (active) { active.controller.abort(); clearTimeout(active.timeout); clearTimeout(active.check); }
      queued = null;
      history.replaceState(null, '', location.href);
      location.reload();
    }
  }, true);
  var style = document.createElement('style');
  // Card images explicitly set visibility:visible. Opacity on the grid masks
  // the entire subtree until the verified batch is ready, without a layout shift.
  style.textContent = 'html[data-vcb-category-heading-aligned] .site-header.header-sticky.is-sticky{animation:none!important;transform:none!important}' +
    'html[data-vcb-category-navigation-pending]{cursor:progress}' +
    'html[data-vcb-category-navigation-pending] #gf-products{opacity:0!important;transition:none!important;visibility:hidden!important;pointer-events:none!important;min-height:420px}' +
    'html[data-vcb-category-navigation-pending] [data-vcb-results-count]{visibility:hidden!important}' +
    '.vcb-category-navigation-loading{padding:24px 0;min-height:64px;font-weight:600;text-align:center}';
  document.head.appendChild(style);
  window.VCBCategoryNavigation = { version: 1, documentId: documentId, handleClick: handleClick };
  monitorApp();
  var bootstrapAttempts = 0, bootstrap = setInterval(function () {
    monitorApp();
    var g = app();
    if (g && g.state && Array.isArray(g.state.products) && g.state.pagination && document.querySelector('#gf-products > .halo-item')) initialObserved = true;
    markInitialGrid();
    if (firstGrid || ++bootstrapAttempts >= 160) clearInterval(bootstrap);
  }, 100);
})();
